import { Dropdown, DropdownProps } from "@/stories/components/Form/Dropdown/Dropdown"

export  type DropFilterProps = {
  title: string,
  className?: string,
  panelClassName?: string
} & DropdownProps

export const DropFilter = ({title, className, panelClassName, children, ...props}: DropFilterProps) => {

  return (
    <Dropdown
      title={title}
      className={className}
      panelClassName={panelClassName}
      {...props}>
      {children}
    </Dropdown>
  )
}